import React from 'react';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import useHomeContext from 'Context/HomeContext';
import RefactoredDialog from './RefactoredDialog';

const DialogPicker = (props) => {
  const { homeResource } = useHomeContext();

  return pickFunction(homeResource, {
    [fr.relationships.default.name]: () => {
      return (
        <RefactoredDialog {...props} />
      );
    },
  });
};

export default DialogPicker;
